import { useRouter } from "next/router";
import { FC, PropsWithChildren, useCallback } from "react";
import Radio from "@/components/Radio";

interface Props {
  href: string;
  checked: boolean;
}

const RadioLink: FC<PropsWithChildren<Props>> = ({
  checked,
  href,
  children,
}): JSX.Element => {
  const router = useRouter();
  const clickHandler = useCallback(() => {
    router.push(href);
  }, [href, router]);

  return (
    <div>
      <button onClick={clickHandler} className="flex items-center space-x-8">
        <Radio checked={checked} />
        <span>{children}</span>
      </button>
    </div>
  );
};
export default RadioLink;
